// extracted by mini-css-extract-plugin
var _1 = "VerifiedIcon-module__info--MhCu4";
var _2 = "VerifiedIcon-module__muted--YpBIW";
var _3 = "VerifiedIcon-module__success--ioNL5";
var _4 = "VerifiedIcon-module__warning--pQoEl";
export { _1 as "info", _2 as "muted", _3 as "success", _4 as "warning" }
